<qai-inner-wrap class="results-accuracy" data-testId="resultsAccuracyTab">
  <ng-container [ngSwitch]="state">
    <app-message-block *ngSwitchCase="AccuracyFeedbackState.Loading" data-testId="accuracyLoadingState">
      <qai-loading size="medium" [label]="'results.ACCURACY_LOADING' | transloco" />
    </app-message-block>

    <app-message-block
      *ngSwitchCase="AccuracyFeedbackState.Clear"
      [icon]="clearIcon"
      data-testId="accuracyClearState"
    >
      {{ 'results.ACCURACY_ALL_CLEAR' | transloco }}
    </app-message-block>

    <app-message-block
      *ngSwitchCase="AccuracyFeedbackState.Error"
      [icon]="errorIcon"
      data-testId="accuracyErrorState"
    >
      {{ 'results.ACCURACY_ERROR' | transloco }}
    </app-message-block>

    <ng-container *ngSwitchCase="AccuracyFeedbackState.Flagged">
      <app-message-block [icon]="flaggedIcon" data-testId="accuracyFlaggedBanner">
        {{ 'results.ACCURACY_FLAGGED_MESSAGE' | transloco }}
      </app-message-block>

      <div class="accuracy-claim" *ngFor="let claim of claims" data-testId="accuracyClaimCard">
        <div class="accuracy-claim__body">
          <qai-comparison-block
            kind="neutral"
            [title]="'results.ACCURACY_YOU_SAID' | transloco"
            [description]="claim.originalClaim"
          />
          <qai-comparison-block
            kind="brand"
            [title]="'results.ACCURACY_CLAIM_IDENTIFIED' | transloco"
            [description]="claim.normalizedClaim"
          />
          <qai-comparison-block
            kind="warning"
            [title]="'results.ACCURACY_MATERIALS_STATE' | transloco"
            [description]="claim.appliedFact"
          />
        </div>
      </div>
    </ng-container>
  </ng-container>
</qai-inner-wrap>
